
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

console.log('%c✦ Glow Lab', 'font-family: serif; font-size: 14px; color: #D4649A;');

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<App />);
} else {
  document.body.innerHTML = `
    <div style="padding: 20px; color: red; background: #ffe6e6;">
      <h1>Element 'root' non trouvé</h1>
    </div>
  `;
}
